export const dateFormat = {
    fullMonthDayYear: 'MMMM DD, YYYY',
    fullDatetime: 'YYYY-MM-DD HH:mm:ss Z',
    shortMonthDayYearAMPMTime: 'MMM D, YYYY h:mm A',
    shortMonthDayYear: 'MMM D, YYYY',
    shortMonthDayWithZeroYear: 'MMM DD, YYYY',
};

export const dateRangeFilterDropdownDateFormat = 'MM/DD/YYYY';
